export default function TieredPricingTableHeader({
													 attributes,
													 quantityColumnLabel,
													 discountColumnLabel,
													 priceColumnLabel
												 }) {
	return (
		<tr style={{textAlign: "left"}}>
			<th>{quantityColumnLabel}</th>

			{
				attributes.showDiscountColumn && 	<th>{discountColumnLabel}</th>
			}

			<th>{priceColumnLabel}</th>
		</tr>
	)
}
